import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class notFound_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `<div class="not-found-wrapper">
    <div class="not-found-content">
        <div class="not-found-number">404</div>
        <h1 class="not-found-title" data-bind="text: message"></h1>
        <p class="not-found-description" data-bind="text: description"></p>
        <a href="/" class="not-found-btn">GO Home</a>
    </div>
</div>

<style>
.not-found-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 70vh;
    padding: 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.not-found-content {
    text-align: center;
    max-width: 600px;
    padding: 40px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.not-found-number {
    font-size: 120px;
    font-weight: 900;
    line-height: 1;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.not-found-title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 16px;
    color: #2d3748;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.not-found-description {
    font-size: 18px;
    margin-bottom: 32px;
    color: #718096;
    line-height: 1.6;
}

.not-found-btn {
    padding: 14px 32px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.not-found-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.not-found-btn:active {
    transform: translateY(0);
}

@media (max-width: 768px) {
    .not-found-number {
        font-size: 80px;
    }
    
    .not-found-title {
        font-size: 24px;
    }
    
    .not-found-description {
        font-size: 16px;
    }
    
    .not-found-content {
        padding: 30px 20px;
    }
}
</style>`;
    }

    protected getTemplateName(): string{
        return "notFound-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            message: ko.observable("Page Not Found")
            ,description: ko.observable("Sorry, we couldn't find the page you're looking for. The page may have been moved, deleted, or the URL might be incorrect.")
            ,buttonText: ko.observable("Go Back Home")
            ,isLoading: ko.observable(0)
        };

    }

    public activateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/notFound_template.ts